var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 453,
    height: 256,
    viewBox: "0 0 453 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_30108)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 453,
    height: 224,
    rx: 20,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 191L318.526 333.5H-62.5256L128 191Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 207L523.526 349.5H142.474L333 207Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 181L417.526 323.5H36.4744L227 181Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 181L417.526 323.5H36.4744L227 181Z",
    fill: "url(#paint0_linear_155_30108)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.375 32V167.827H221.458C192.827 167.827 169.614 137.42 169.614 99.9137C169.614 62.4072 192.827 32 221.458 32H232.375Z",
    fill: "#F97316"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.311 123.561C173.78 125.213 174.303 126.827 174.865 128.412H232.844V123.561H173.311Z",
    fill: "#FDBA74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.451 136.904C179.279 138.572 180.162 140.189 181.098 141.755H232.844V136.904H178.451Z",
    fill: "#FDBA74"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.67 110.222C170.86 111.861 171.11 113.475 171.389 115.073H232.844V110.222H170.67Z",
    fill: "#FDBA74"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.113 150.243C188.553 151.947 190.09 153.567 191.717 155.094H232.845V150.243H187.113Z",
    fill: "#FDBA74"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M232.844 165.402V160.551H198.601C201.598 162.548 204.824 164.177 208.211 165.402H232.844Z",
    fill: "#FDBA74"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M171.602 83.5435C171.301 85.1288 171.047 86.7554 170.835 88.3915H232.844V83.5435H171.602Z",
    fill: "#FDBA74"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.134 96.8828C170.102 97.8879 170.077 98.8962 170.077 99.914C170.077 100.523 170.099 101.125 170.112 101.734H232.844V96.8828H170.134Z",
    fill: "#FDBA74"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M212.19 33.2114C208.078 34.247 204.14 35.8816 200.503 38.0626H232.844V33.2114H212.19Z",
    fill: "#FDBA74"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M193.027 43.5229C191.314 45.0395 189.696 46.6596 188.182 48.3742H232.844V43.5229H193.027Z",
    fill: "#FDBA74"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M181.828 56.8618C180.851 58.4218 179.927 60.0389 179.056 61.713H232.844V56.8618H181.828Z",
    fill: "#FDBA74"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M175.296 70.2012C174.706 71.7865 174.173 73.4068 173.679 75.0524H232.844V70.2012H175.296Z",
    fill: "#FDBA74"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M232.676 167.827C261.309 167.827 284.521 137.421 284.521 99.9137C284.521 62.406 261.309 32 232.676 32C204.043 32 180.832 62.406 180.832 99.9137C180.832 137.421 204.043 167.827 232.676 167.827Z",
    fill: "#F97316"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M232.676 156.306C254.947 156.306 273.002 131.058 273.002 99.9142C273.002 68.7702 254.947 43.5229 232.676 43.5229C210.405 43.5229 192.351 68.7702 192.351 99.9142C192.351 131.058 210.405 156.306 232.676 156.306Z",
    fill: "#FDBA74"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M253.575 110.705C253.762 104.664 250.998 100.664 246.811 98.9355C249.918 97.1037 252.07 93.6508 252.212 88.8732C252.393 82.9359 249.218 78.6218 242.999 77.0179L243.228 69.6866L236.458 69.4709L236.236 76.2862L232.391 76.1651L232.613 69.3498L225.849 69.1349L225.628 75.9502L219.463 75.7599L215.168 75.6268L214.952 82.3971L219.247 82.5302L218.247 115.463L213.503 115.311L213.288 122.081L218.032 122.227L224.197 122.417L223.957 130.342L230.721 130.557L230.968 122.633L234.812 122.754L234.566 130.678L241.336 130.894L241.583 122.708C249.253 121.881 253.358 117.586 253.575 110.705ZM227.841 82.8102L237.004 83.0913C242.087 83.2473 244.904 85.4609 244.775 89.7756C244.646 94.0904 241.698 96.0539 236.605 95.9229L226.178 95.5971L226.568 82.7905L227.841 82.8102ZM237.453 116.053L226.374 115.709L225.592 115.687L226.006 102.281L237.88 102.649C243.413 102.817 246.349 104.968 246.205 109.608C246.06 114.247 243.012 116.224 237.453 116.053Z",
    fill: "#F97316"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_155_30108",
    x1: 227,
    y1: 181,
    x2: 227,
    y2: 258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD5E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_30108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 453,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoImage);
export default __webpack_public_path__ + "static/media/crypto_image.90701b0262650fb1354c312646979c8d.svg";
export { ForwardRef as ReactComponent };